exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsletters {\n    background-color: white;\n    height: 60em;\n}\n\n.newsletter-display:hover {\n    font-weight: bold;\n}", ""]);

// exports
